import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Button, Grid, Message, Modal } from 'semantic-ui-react';

// Actions
// @ts-ignore
import { updateQueryString } from 'services/router/actions';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

import {
    makeSelectQueryStringBooleanValue,
    makeSelectQueryStringNumberValue
    // @ts-ignore
} from 'workspaces/react-router-selectors';

// Global Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
// @ts-ignore
import ErrorAlert from 'components/ErrorAlert';
import FinalFormUnsavedValuesExistGate from 'components/FinalFormUnsavedValuesExistGate';

// Child Components
import TimesheetApproveModalButton from './components/TimesheetApproveModalButton';

interface StateProps {
    isOpen?: boolean;
    id?: number;
}

interface DispatchProps {
    updateQueryString: Function;
}

type IProps = StateProps & DispatchProps;

export class TimesheetApproveModal extends React.PureComponent<IProps> {
    handleClose = () => {
        this.props.updateQueryString({
            timesheetApproveModal: undefined,
            selectedTimesheet: undefined
        });
    };

    render(): React.ReactElement | null {
        const { isOpen, id } = this.props;

        if (!id) return null;

        return (
            <Modal
                size="tiny"
                open={isOpen}
                centered={false}
                onClose={this.handleClose}
                closeIcon
            >
                <ErrorBoundary
                    namespace="TimesheetApproveModal"
                    FallbackComponent={<ErrorBoundaryAlert />}
                >
                    <Modal.Header>Approve Timesheet</Modal.Header>
                    <Modal.Content>
                        <FinalFormUnsavedValuesExistGate
                            namespace={`TimesheetTimesheetEntriesForm.${id}`}
                        >
                            <Message negative>
                                Unsaved changes will be lost
                            </Message>
                        </FinalFormUnsavedValuesExistGate>
                        <ErrorAlert namespace="TIMESHEET_APPROVE" />
                        <Grid centered>
                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                <Button
                                    type="button"
                                    onClick={this.handleClose}
                                    fluid
                                    basic
                                    primary
                                >
                                    Cancel
                                </Button>
                            </Grid.Column>
                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                <TimesheetApproveModalButton timesheetId={id} />
                            </Grid.Column>
                        </Grid>
                    </Modal.Content>
                </ErrorBoundary>
            </Modal>
        );
    }
}

const mapStateToProps = createStructuredSelector<any, any>({
    isOpen: makeSelectQueryStringBooleanValue('timesheetApproveModal'),
    id: makeSelectQueryStringNumberValue('selectedTimesheet')
});

export default connect<StateProps, DispatchProps>(
    mapStateToProps,
    {
        updateQueryString
    }
)(TimesheetApproveModal);
